import React from 'react'
import { View, TouchableOpacity } from 'react-native'
import { AppModal as Modal } from '@components'
import { useTheme } from '@react-navigation/native'
import { Text, Icon } from '@components'
import { useLanguage } from '@context'
import getStyle from './style'

interface GroupActionsModalProps {
  visible: boolean
  onClose: () => void
  groupName: string
  onShare: () => void
  onViewMembers: () => void
  onCustomizeGroup: () => void
  onBlock: () => void
  onReport: () => void
}

export const GroupActionsModal: React.FC<GroupActionsModalProps> = ({
  visible,
  onClose,
  groupName,
  onShare,
  onViewMembers,
  onCustomizeGroup,
  onBlock,
  onReport
}) => {
  const theme = useTheme()
  const { t } = useLanguage()
  const styles = getStyle(theme)

  const normalActions = [
    {
      icon: 'share' as const,
      label: t('messagesScreen.share'),
      onPress: onShare,
    },
    {
      icon: 'users' as const,
      label: t('messagesScreen.viewMembers'),
      onPress: onViewMembers,
    },
    {
      icon: 'edit' as const,
      label: t('messagesScreen.customizeGroup'),
      onPress: onCustomizeGroup,
    }
  ]

  const dangerActions = [
    {
      icon: 'crossOctagon' as const,
      label: t('messagesScreen.block'),
      onPress: onBlock,
    },
    {
      icon: 'alertTriangle' as const,
      label: t('messagesScreen.report'),
      onPress: onReport,
    }
  ]

  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onClose}
    >
      <TouchableOpacity 
        style={styles.modalOverlay}
        activeOpacity={1}
        onPress={onClose}
      >
        <TouchableOpacity 
          style={styles.modalContainer}
          activeOpacity={1}
        >
          {/* Header du modal */}
          <View style={styles.modalHeader}>
            <Text type="title" style={styles.modalTitle}>
              {t('messaging.aboutGroup')}
            </Text>
            <TouchableOpacity onPress={onClose} style={styles.closeButton}>
              <Icon name="cross" size={20} color={theme.colors.secondary} />
            </TouchableOpacity>
          </View>

          {/* Actions normales */}
          <View style={styles.actionsContainer}>
            {normalActions.map((action, index) => (
              <TouchableOpacity
                key={index}
                style={[
                  styles.actionItem,
                  index < normalActions.length - 1 && styles.actionItemBorder
                ]}
                onPress={() => {
                  action.onPress()
                  onClose()
                }}
              >
                <Icon 
                  name={action.icon} 
                  size={20} 
                  color={theme.colors.secondary} 
                />
                <Text 
                  type="body" 
                  style={styles.actionLabel}
                >
                  {action.label}
                </Text>
              </TouchableOpacity>
            ))}
          </View>

          {/* Divider plus marqué */}
          <View style={styles.actionItemDivider} />

          {/* Actions dangereuses */}
          <View style={styles.actionsContainer}>
            {dangerActions.map((action, index) => (
              <TouchableOpacity
                key={index}
                style={[
                  styles.actionItem,
                  index < dangerActions.length - 1 && styles.actionItemBorder
                ]}
                onPress={() => {
                  action.onPress()
                  onClose()
                }}
              >
                <Icon 
                  name={action.icon} 
                  size={20} 
                  color={theme.colors.error} 
                />
                <Text 
                  type="body" 
                  style={styles.dangerActionLabel}
                >
                  {action.label}
                </Text>
              </TouchableOpacity>
            ))}
          </View>
        </TouchableOpacity>
      </TouchableOpacity>
    </Modal>
  )
} 